import service from "@/api/service";
import { GetResponse } from "@/api/ticket-order-shop/response";
import { SearchRequest } from "@/api/ticket-order-shop/request";
import { SearchResponse } from "@/api/ticket-order-shop/response";

/**
 * チケット受注管理店舗情報一覧・検索APIをコールします。
 *
 * @param searchRequest チケット受注管理店舗検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post(
    "/search-ticket-order-shop",
    searchRequest
  );
  return response.data as SearchResponse;
}

/**
 * チケット受注管理店舗情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-ticket-order-shop");
  return response.data as GetResponse;
}
